import React, { FC, useEffect } from "react";
import {
  Content,
  ContentWrapper,
  Heading,
} from "containers/RightPanel/RightPanel.styles";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  getManifestDetail,
} from "../../../../reduxFolder/reducers/historyReducer";
import { authSelectUnits } from "../../../../reduxFolder/selectors/globalSelectors";
import {
  historySelectDetailedLoading,
  historySelectManifestDetail,
} from "../../../../reduxFolder/selectors/historySelector";
import Logo from "../../../../components/Logo/Logo";
import { toastResponseError } from "../../../../utils/responseMessageHelper";
import Parcel from "../Parcel/Parcel";
import { Spinner, VertLine } from "./WeekComponents.styles";

interface ManifestDetailPanelProps {
  isOpen: boolean;
  units: string;
  isDetailedLoading: boolean;
  manifestDetail: any;
  panelData: any;
  getManifestDetail: (id: number) => Promise<void>;
}

const ManifestDetailPanel: FC<ManifestDetailPanelProps> = ({
  isOpen,
  panelData,
  manifestDetail,
  units,
  getManifestDetail,
  isDetailedLoading,
}) => {
  const manifestId = panelData.get("manifestId");
  const batchNumber = panelData.get("batchNumber");
  const shipperName = panelData.get("shipperName");
  const logoUrl = panelData.get("logoUrl");
  const foundConsolidationId = panelData.get("foundConsolidationId");

  const manifest = manifestDetail.get(manifestId);
  const orders = manifest ? manifest.get("orders") : null;

  useEffect(() => {
    if (isOpen && manifestId) {
      getManifestDetail(manifestId).catch(toastResponseError);
    }
  }, [isOpen, manifestId, getManifestDetail]);

  return (
    <ContentWrapper>
      <Spinner isActive={isDetailedLoading && !orders} />
      {orders && (
        <>
          <Heading $isBordered style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {logoUrl && <Logo image={logoUrl} size={20} />}
            <strong>{shipperName}</strong>
            <VertLine>|</VertLine>
            {batchNumber}
          </Heading>
          <Content>
            {orders.map((order: any, index: number) => (
              <Parcel
                units={units}
                parcel={order}
                key={order.getIn(["consolidation", "id"], index)}
                foundConsolidationId={foundConsolidationId}
              />
            ))}
          </Content>
        </>
      )}
    </ContentWrapper>
  );
};

const withConnect = connect(
  createStructuredSelector({
    manifestDetail: historySelectManifestDetail,
    isDetailedLoading: historySelectDetailedLoading,
    units: authSelectUnits,
  }),
  { getManifestDetail },
);

export default withConnect(ManifestDetailPanel);
